import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../../Constants";
// import { PageService } from "../../../Services";
import { Card } from "react-bootstrap";
import PageForm from "./Form/PageForm";

function PageEdit() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const navigate = useNavigate();

  const onSubmit = (model) => {
    setIsSubmitting(true);
    // PageService.update(id, page)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });
    const pages = JSON.parse(sessionStorage.getItem("pages"));
    const updatedPages = pages.map((item) => (item.id === id ? model : item));
    sessionStorage.setItem("pages", JSON.stringify(updatedPages));

    const questions = JSON.parse(sessionStorage.getItem("questions"));
    if (model.questions?.length > 0) {
      const questionIds = model.questions.map((i) => i.id);
      const currentIds = questions.map((i) => i.id);

      const toUpdate = questions.map((obj, idx) =>
        questionIds.includes(obj.id)
          ? model.questions.find((i) => i.id === obj.id)
          : obj
      );
      const toMerge = model.questions.filter((i) => !currentIds.includes(i.id));
      console.log(toUpdate);
      console.log(toMerge);

      sessionStorage.setItem(
        "questions",
        JSON.stringify([...toUpdate, ...toMerge])
      );
    }
    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie edytowano stronę ${model.name}`);
    navigate(`/${RoutePathConstants.Page}`);
  };

  useEffect(() => {
    setIsLoading(true);
    // DO IMPLEMENTACJI
    // PageService.getById(id)
    //   .then((res) => {
    //     const page = {
    //       ...res.data,
    //       relatedPages: res.data.relatedPages.sort((a, b) => a.order - b.order),
    //     };
    //     setModel(report);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });

    const pages = JSON.parse(sessionStorage.getItem("pages"));
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    if (!!pages) {
      const page = pages.find((i) => i.id === id);
      page.questions = [];
      if (!!questions)
        page.questions = questions.filter((i) => i.pageId === page.id);
      setModel(page);
      setIsLoading(false);
    }
  }, [id]);

  return (
    <>
      <PageHeader content={PageTitleConstants.PageEdit} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            model && (
              <PageForm
                onSubmit={onSubmit}
                model={model}
                isEdit={true}
                isSubmitting={isSubmitting}
              />
            )
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default PageEdit;
